import { NgModule } from '@angular/core';
//import { RamastanDataService } from './services/ramastandata.service'
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Routes,RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import { AppComponent } from './components/app/app.component';
import { HomeComponent } from './components/home/home.component';
import { RamastanHeaderComponent } from './components/ramastanheader/ramastanheader.component';
import { RamastanFooterComponent } from './components/ramastanfooter/ramastanfooter.component';
//import { HeadQuartersComponent } from './components/contact/headquarters/headquarters.component';
//import { CareersComponent } from './components/careers/careers.component';

@NgModule({
    declarations: [
        AppComponent,        
        //HeadQuartersComponent,
        //CareersComponent,       
        HomeComponent,        
        RamastanHeaderComponent,
        RamastanFooterComponent        
    ],
    imports: [
        CommonModule,
        HttpModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot([
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            //{ path: 'careers', component: CareersComponent },
            //{ path: 'headquarters', component: HeadQuartersComponent },           
            {
                path: 'news', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\components\\news\\news.module')['NewsModule']);  });})
            },
            {
                path: 'solutions', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\components\\solutions\\solutions.module')['SolutionsModule']);  });})
            },   
            {
                path: 'contact', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\components\\contact\\contact.module')['ContactModule']);  });})
            },
            {
                path: 'careers', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\components\\careers\\careers.module')['CareersModule']);  });})
            },       
            { path: '**', redirectTo: 'home' }
        ]),
        MaterialModule,        
    ]
    //,
    //providers: [RamastanDataService]
})
export class AppModuleShared {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/app.shared.module.ts